import request from '@/utils/request'

//我的资料
export function myData(data) {
    return request({
        url: '/api/user/info',
        method: 'post',
        params: data
    })
}
// 我的关注
export function myFollows(data) {
    return request({
        url:'/api/follow/index',
        method:'post',
        params: data
    })
}
//通过关注ID取消关注
export function Cancel(data){
    return request({
        url:"/api/follow/destroy",
        method:"post",
        params:data
    })
}
//我的粉丝
export function myFans(data){
    return request({
        url:"/api/my/fans",
        method:"post",
        params:data
    })
}
//关注
export function Gfollow(data){
    return request({
        url:"/api/follow/save",
        method:"post",
        params:data
    })
}
//取消关注通过用户id
export function CancelDelete(data){
    return request({
        url:"/api/follow/delete",
        method:"post",
        params:data
    })
}
//猫币明细
export function myGold(data){
    return request({
        url:"/api/gold/index",
        method:"post",
        params:data
    })
}
//积分明细
export function myScore(data){
    return request({
        url:"/api/score/index",
        method:"post",
        params:data
    })
}
//查询最新的签到记录
export function record(data){
    return request({
        url:"/api/sign/record",
        method:"post",
        params:data
    })
}
//判断是否签到
export function is_sign(data){
    return request({
        url:"/api/sign/is_sign",
        method:"post",
        params:data
    })
}
//签到
export function save(data){
    return request({
        url:"/api/sign/save",
        method:"post",
        params:data
    })
}
//每日任务
export function everydayTask(data){
    return request({
        url:"/api/task/task",
        method:"post",
        params:data
    })
}
//新手任务
export function once(data){
    return request({
        url:"/api/task/once",
        method:"post",
        params:data
    })
}
//推广任务判断
export function pushtask(data){
    return request({
        url:"/api/push/task",
        method:"post",
        params:data
    })
}
//推广有礼
export function pushpolite(data){
    return request({
        url:"/api/push/index",
        method:"post",
        params:data
    })
}
//推广二维码
export function pushpurl(data){
    return request({
        url:"/api/push/url",
        method:"post",
        params:data
    })
}
//邀请列表
export function invite(data){
    return request({
        url:"/api/invite/index",
        method:"post",
        params:data
    })
}
//VIP兑换列表
export function VIPlist(data){
    return request({
        url:"/api/vip/index",
        method:"post",
        params:data
    })
}
//VIP兑换列表
export function VIPtotal(data){
    return request({
        url:"/api/vip/total",
        method:"post",
        params:data
    })
}
//VIP激活码兑换
export function VIPkey(data){
    return request({
        url:"/api/vip/key",
        method:"post",
        params:data
    })
}
//热门视频推荐
export function videovideo(data){
    return request({
        url:"/api/video/hot",
        method:"post",
        params:data
    })
}
//我的评论导航
export function cate(data){
    return request({
        url:"/api/comments/cate",
        method:"post",
        params:data
    })
}
//取消点赞
export function comment(data){
    return request({
        url:"/api/comment/delete",
        method:"post",
        params:data
    })
}
//我的点赞
export function cliked(data){
    return request({
        url:"/api/likes/index ",
        method:"post",
        params:data
    })
}
//取消点赞
export function praise(data){
    return request({
        url:"/api/praise/delete",
        method:"post",
        params:data
    })
}
//我的收藏导航
export function collectscate(data){
    return request({
        url:"/api/collects/cate",
        method:"post",
        params:data
    })
}
//我的收藏列表
export function collects(data){
    return request({
        url:"/api/collects/index ",
        method:"post",
        params:data
    })
}
//取消收藏
export function collect(data){
    return request({
        url:"/api/collect/destroy",
        method:"post",
        params:data
    })
}
//查看用户帖子列表
export function userpost(data){
    return request({
        url:"/api/user/index",
        method:"post",
        params:data
    })
}
//查看用户详情顶部广告
export function user_top(data){
    return request({
        url:"/api/ad/user_top",
        method:"get",
        params:data
    })
}
//帮助中心列表
export function help(data){
    return request({
        url:"/api/help/index",
        method:"post",
        params:data
    })
}
//帮助详情
export function helpdetail(data){
    return request({
        url:"/api/help/detail",
        method:"post",
        params:data
    })
}
//制作类型
export function videotype(data){
    return request({
        url:"/api/video/type",
        method:"post",
        params:data
    })
}
//电影分类
export function videocate(data){
    return request({
        url:"/api/video/cate",
        method:"post",
        params:data
    })
}
//电影区域
export function videoregion(data){
    return request({
        url:"/api/video/region",
        method:"post",
        params:data
    })
}
//电影
export function videoindex(data){
    return request({
        url:"/api/video/index",
        method:"post",
        params:data
    })
}
//意见反馈
export function feedback(data){
    return request({
        url:"/api/feedback/index",
        method:"post",
        params:data
    })
}
//修改密码
export function change_pwd(data){
    return request({
        url:"/api/user/change_pwd",
        method:"post",
        params:data
    })
}
//修改昵称
export function user_change(data){
    return request({
        url:"/api/user_change/nickname",
        method:"post",
        params:data
    })
}
//个性签名
export function signature(data){
    return request({
        url:"/api/user_change/signature",
        method:"post",
        params:data
    })
}
//修改头像
export function user_change_photo(data){
    return request({
        url:"/upload/api/user_change/photo",
        method:"post",
        data:data
    })
}
//修改性别
export function user_change_sex(data){
    return request({
        url:"/api/user_change/sex",
        method:"post",
        params:data
    })
}
//查询
export function userextra(data){
    return request({
        url:"/api/dic/userextra",
        method:"post",
        params:data
    })
}
//交友意向
export function friendshipIntention(data){
    return request({
        url:"/api/user_change/friendshipIntention",
        method:"post",
        params:data
    })
}
//性取向
export function sexualOrientation(data){
    return request({
        url:"/api/user_change/sexualOrientation",
        method:"post",
        params:data
    })
}
//评论列表
export function catelist(data){
    return request({
        url:"/api/comments/index",
        method:"post",
        params:data
    })
}
//不是vip剩余观看次数
export function user_view(data){
    return request({
        url:"/api/homepage/views",
        method:"post",
        params:data
    })
}
//勋章列表
export function medalindex(data){
    return request({
        url:"/api/v2/medal/index",
        method:"post",
        params:data
    })
}
//勋章获取活动
export function geekcate(data){
    return request({
        url:"/api/v2/geek/cate",
        method:"post",
        params:data
    })
}
//删除帖子
export function mydel(data){
    return request({
        url:"/api/post/delete",
        method:"post",
        params:data
    })
}
//删除视频
export function originaldelete(data){
    return request({
        url:"/api/original/delete",
        method:"post",
        params:data
    })
}



// WEBPACK FOOTER //
// ./src/api/my.js